// ============================================================
// FILE: resources/js/components/priceCalc.js
// USPATIH GO — Alpine Component: Price Calculator (Digital Printing)
// ============================================================

import Alpine        from 'alpinejs';
import { formatRupiah } from '../helpers/formatters.js';

Alpine.data('priceCalc', () => ({
  width:      0,
  height:     0,
  qty:        1,
  pricePerM2: 0,

  // ---- Kalkulasi -----------------------------------------------
  get areaCm2()   { return this.width * this.height; },
  get areaM2()    { return this.areaCm2 / 10000; },
  get unitPrice() { return this.areaM2 * this.pricePerM2; },
  get total()     { return this.unitPrice * this.qty; },

  /**
   * Nilai terformat siap tampil di UI
   */
  get formatted() {
    return {
      area:      this.areaM2.toFixed(4) + ' m²',
      unitPrice: formatRupiah(Math.ceil(this.unitPrice)),
      total:     formatRupiah(Math.ceil(this.total)),
    };
  },

  /**
   * Hitung berapa lembar produk muat di bahan cetak
   * @param {number} materialW  - lebar bahan (cm), default 100
   * @param {number} materialH  - tinggi bahan (cm), default 100
   * @param {number} bleedCm    - bleed antar produk (cm), default 0.3
   * @returns {object|null}
   */
  fitInMaterial(materialW = 100, materialH = 100, bleedCm = 0.3) {
    if (!this.width || !this.height) return null;

    const cols  = Math.floor(materialW / (this.width  + bleedCm));
    const rows  = Math.floor(materialH / (this.height + bleedCm));
    const total = cols * rows;
    const waste = (100 - (total * this.areaCm2 / (materialW * materialH)) * 100).toFixed(1) + '%';

    return { cols, rows, total, waste };
  },
}));
